var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaldo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34314 19.5V19.8525H4.38611V19.5H5.34314Z",
    fill: "#27AE60",
    stroke: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8628 19.5V19.8525H18.9058V19.5H19.8628Z",
    fill: "#27AE60",
    stroke: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0392 17.1957H3.03209C2.49828 17.1957 2.03564 16.7687 2.03564 16.1993V8.19218C2.03564 7.65837 2.46269 7.19574 3.03209 7.19574H21.0392C21.573 7.19574 22.0356 7.62279 22.0356 8.19218V16.2349C22.0356 16.7687 21.573 17.1957 21.0392 17.1957Z",
    stroke: "#27AE60",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27747 9.1192H14.0284C14.1935 9.1192 14.3467 9.2651 14.3468 9.43756V15.0245C14.3468 15.161 14.2295 15.3077 14.0284 15.3077H4.27747C4.11245 15.3076 3.95911 15.1618 3.95911 14.9893V9.43756C3.95919 9.27258 4.10505 9.11929 4.27747 9.1192Z",
    stroke: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.548 11.0765C19.2545 11.0765 19.8272 11.6493 19.8273 12.3558C19.8273 13.0624 19.2545 13.6351 18.548 13.6351C17.8414 13.6351 17.2687 13.0624 17.2687 12.3558C17.2687 11.6493 17.8415 11.0766 18.548 11.0765Z",
    stroke: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaldo);
export default __webpack_public_path__ + "static/media/saldo.9b8fc285cea71ae60fe8d7f8118ea6ab.svg";
export { ForwardRef as ReactComponent };